/**
 * Styled Components - Created by cazarez on 21/03/18.
 */
import styled from 'styled-components'
import { SecondaryCTA } from '../../theme/components'

export const Text = styled.div`
  color: #fff;
`

export const ShareLinkContainer = styled.div`
  flex: 2;
  width: 100%;

  .link-copy-row {
    display: flex;
    align-items: center;
    width: 100%;
  }
`

export const QRCodeDiv = styled.div`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`
export const QrCodeIcon = styled.img`
  width: 28px;
  filter: hue-rotate(45deg);
`

export const Title = styled.div`
  margin-bottom: 5px;
  color: #5f6062;
  font-size: 14px;
  line-height: 19px;
  @media (max-width: 698px) {
    white-space: nowrap;
  }
`
export const Asterisk = styled.span`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  margin-left: 5px;
`
export const ShareInputWrapper = styled.div`
  input {
    border-radius: 0;
  }
  .ant-btn {
    border-radius: 0;
    background-color: #4a90e2;
    border-color: #4a90e2;
    &:hover {
      background-color: #4a90e2;
      border-color: #4a90e2;
    }
  }
`

export const InputWrapper = styled.div`
  .ant-input {
    margin-bottom: 26px;
    height: 40px;
    border-radius: 0;
    color: #bebebe;
    font-size: 16px;
    line-height: 22px;
  }
`

export const ShareSocialMediaContainer = styled.div`
  text-align: center;
  margin-right: 54px;
  @media (max-width: 698px) {
    margin-right: 8px;
  }
`
export const ShareByMailRow = styled.div``

export const IconsRow = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 12px;
  @media (max-width: 698px) {
    margin-top: 12px;
  }
`

export const RowShare = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: center;
  @media (max-width: 368px) {
    flex-wrap: wrap;
  }
`

export const FacebookIconImg = styled.img`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`
export const TwitterIconImg = styled.img`
  width: 28px;
  &:hover {
    cursor: pointer;
  }
`

export const SendButtonWrapper = styled.div`
  text-align: right;
  .ant-btn {
    height: 40px;
    width: 138.23px;
    border-radius: 2px;
    background-color: #4a90e2;
    color: #fff;
  }
`

export const SendEmailButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  @media (max-width: 698px) {
    white-space: nowrap;
  }
`

export const SendEmailButton = styled.div`
  background-color: #4a90e2;
  padding: 8px 10px;
  width: fit-content;
  color: white;
  font-size: medium;
  font-weight: 400;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 1px lightgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: white;
    color: #4a90e2;
  }
`

export const SendIcon = styled.img`
  max-width: 20px;
  margin-left: 8px;
  vertical-align: bottom;
`

export const ShareIconBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: var(--radius-full);
  background: var(--neutral-lightest-block);
  flex-shrink: 0;
`

export const ShareBadgeIcon = styled.img`
  display: block;
  width: 26px;
  height: 26px;
  object-fit: contain;
`

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .modal-heading {
    margin: 0;
    font: 600 32px/38px var(--font-barlow-semi-condensed);
    color: var(--neutral-darkest);
    text-transform: capitalize;
  }
`

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  min-width: 0;
  height: 42px;
  padding: 0 var(--spacing-8) 0 16px;
  gap: var(--spacing-12);
  background: var(--neutral-fill-lightest);
  border: var(--border-regular) solid var(--neutral-border-med);
  border-radius: 0;
`

export const HiddenCopyInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export const UrlText = styled.p`
  flex: 1;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 400 14px/22px var(--font-inter);
  color: var(--neutral-darkest);
`

export const CopyCta = styled(SecondaryCTA)`
  width: 72px;
  max-width: 72px;
  flex-shrink: 0;
`

export const IconImg = styled.img`
  object-fit: contain;
  &.social {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  &.mail {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`

export const Container = styled.div`
  padding: 2px;

  &[data-appearance='v2'] {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);

    ${Title} {
      margin-bottom: 0;
      font: 600 12px/18px var(--font-barlow);
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--neutral-darkest);
    }

    ${ShareLinkContainer} {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);
    }

    ${RowShare} {
      margin-top: 0;
      justify-content: flex-start;
    }

    ${ShareSocialMediaContainer} {
      margin-right: 0;
      text-align: left;
    }

    ${IconsRow} {
      margin-top: 0;
      justify-content: flex-start;
      gap: var(--spacing-12);
    }

    ${FacebookIconImg} {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ShareDesignModal/styledComponents.tsx